// Centralized React Query keys, so invalidation/refetch call sites don't hand-roll array shapes.
export const queryKeys = {
  applications: (userEmail?: string) => ['applications', userEmail] as const,
  dataProcessingStatus: (jobId?: string | null) => ['dataProcessingStatus', jobId] as const,
  startDataProcessing: ['startDataProcessing'] as const,
  generateMeta: ['generateMeta'] as const,
};
